/* @jsx h */
import { defineComponent, h } from "vue";
import { GroupOverviewDashboard } from "./components/GroupOverviewDashboard";

export const GroupOverviewPage = defineComponent({
  name: "GroupOverviewPage",
  setup() {
    return () => <GroupOverviewDashboard />;
  },
});
